<template>
  <div class="swiper" v-if="videoList.length">
    <swiper
    :options="swiperOption"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
    >
      <swiper-slide class="swiper_slide" v-for="(t,i) in videoList" :key="i">
        <img :src="t.poster" alt="">
        <div class="swiper_slide-text">{{t.text}}</div>
        <div v-if="t.unit" class="swiper_slide-desc">{{t.unit}}</div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination"></div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>
let that = null
export default {
  created() {
    that = this
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlidesBounds: true,
        effect: 'coverflow',
        initialSlide: 0,
        // autoHeight: true,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // autoplay: {
        //   delay: 2000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        coverflowEffect: {
          // rotate: 0,
          stretch: 25,
          depth: 60,
          modifier: 1,
          slideShadows: false
        },
        loop: true,
        on: {
          tap: function(e) {
            var index = e.realIndex;
            var item;
            item = that.videoList[index]
            that.selectLive(item)
            // if (once > 0 && index === 0) {
            //   item = that.videoList[index + 2]
            //   that.selectLive(item)
            // } else {
            //   item = that.videoList[index]
            //   that.selectLive(item)
            //   once--
            // }
          }
        }
      },
      once: 1,
      slider: []
    }
  },
  props: {
    videoList: {
      type: Array,
      default: () => {
        return []
      }
    },
    live: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
  },
  mounted() {

  },
  methods: {
    // 选择直播
    selectLive(data) {
      this.$emit('update:live', data)
    },
    onSwiper () {

    },
    onSlideChange () {

    }
  }
}
</script>

<style lang="scss" scoped>
  .swiper {
    width: 95%;
    margin: 0 auto;
    overflow: hidden;
  }
  .swiper-button-next::after, .swiper-button-prev::after {
    font-size: 30px !important;
    margin-top: calc(0px - (var(--swiper-navigation-size)/ 1.6));
    color: #fff;
  }
  .swiper_slide {
    width: 80% !important;
    img {
      width: 100%;
      height: 1.52rem;
      cursor: pointer;
      max-height: 1.6rem;
      box-shadow: 0 0 6px rgb(77, 77, 77);
    }
    &-desc {
      font-size: .13rem;
      color: #fff;
      text-align: center;
      margin-top: .05rem;
    }
  }
  .swiper_slide-text {
    color: #fff;
    // background: #fff;
    text-align: center;
    font-size: .16rem;
    line-height: .2rem;
    box-sizing: border-box;
    padding: 0 .15rem;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
</style>
